










































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip, mdbRow, mdbCol, mdbCard, mdbCardImage, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardFooter, mdbCardUp, mdbCardAvatar, mdbCardGroup, mdbView, mdbMask } from '@folky-tools/mdbvue';
import { usersService, associationFrontPagesService, associationsService, companiesService, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { AssociationFrontPageSummary } from '@/models/associations/association-front-page-sumary';
import { Association } from '@/models/associations/association';
import { Company } from '@/models/companies/company';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardImage,
        mdbCardHeader,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        mdbCardFooter,
        mdbCardUp,
        mdbCardAvatar,
        mdbCardGroup,
        mdbView,
        mdbMask,
        AssociationBasicData: () => import('@/components/associations/AssociationBasicData.vue'),
        CompanyData: () => import('@/components/companies/CompanyData.vue'),
        FormModal: () => import('@/components/shared/FormModal.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class AssociationDashboardView extends Vue {
    private associationFrontPageSummary: AssociationFrontPageSummary = new AssociationFrontPageSummary();
    private association: Association = new Association();
    private associationCopy: Association = new Association();
    private associationCompany: Company = new Company();
    private associationCompanyCopy: Company = new Company();

    private showEditBasicData: boolean = false;
    private showEditBillingData: boolean = false;

    private savingBasicData: boolean = false;
    private savingBillingData: boolean = false;

    private associationDataLoaded: boolean = false;

    private async created(): Promise<void> {
        this.associationFrontPageSummary = await associationFrontPagesService.getFrontPageSummary(+this.$route.params.id);

        this.association = await associationsService.getAssociation(+this.$route.params.id);
        this.associationCopy = this.association.clone();

        if (this.association.companyId) {
            this.associationCompany = await companiesService.getCompany(this.association.companyId!);
            this.associationCompanyCopy = this.associationCompany.clone();
        }

        this.associationDataLoaded = true;
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.associations.associationDashboardView.title', this.association.name);

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Associations,
                scope: UserActionScopeType.Dashboard,
                entityId: +this.$route.params.id
            })
        );
    }

    private editAssociationBasicData(): void {
        this.showEditBasicData = true;
    }

    private async saveAssociationBasicData(): Promise<void> {
        this.savingBasicData = true;

        if ((this.$refs.associationBasicData as any).hasErrors()) {
            this.savingBasicData = false;
            return;
        }
        try {
            if (await associationsService.updateAssociation(this.association)) {
                this.associationCopy = this.association.clone();
                this.showEditBasicData = false;

                notificationsService.showToastSuccessNotification('views.associations.associationDashboardView.editBasicData.save.successMessage');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Associations,
                        scope: UserActionScopeType.BasicData,
                        entityId: this.association.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingBasicData = false;
        }
    }

    private closeAssociationBasicDataEdition(): void {
        this.association = this.associationCopy.clone();
        this.showEditBasicData = false;
    }

    private editAssociationBillingData(): void {
        this.showEditBillingData = true;
    }

    private async saveAssociationBillingData(): Promise<void> {
        this.savingBillingData = true;

        if ((this.$refs.associationBillingData as any).hasErrors()) {
            this.savingBillingData = false;
            return;
        }

        try {
            const updateResult = await associationsService.updateAssociationCompany(this.association.id, this.associationCompany);
            if (updateResult.result) {
                this.association.companyId = updateResult.id;
                this.association.companyId = updateResult.id;
                this.showEditBillingData = false;

                notificationsService.showToastSuccessNotification('views.associations.associationDashboardView.editBillingData.save.successMessage');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Associations,
                        scope: UserActionScopeType.BillingData,
                        entityId: this.association.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingBillingData = false;
        }
    }

    private closeAssociationBillingDataEdition(): void {
        this.associationCompany = this.associationCompanyCopy.clone();
        this.showEditBillingData = false;
    }
}
